import {
  ILogMessage,
  LoggingService,
} from "../../../shared/services/Logging.service";
import { AppDispatch } from "../../store";

/**
 * @export
 * @class DispatchLogger
 *
 * Utility class that allows you to dispatch an action,
 * and log a meessage at the same time.
 */
export class DispatchLogger {
  private dispatch: AppDispatch;
  private static instance: DispatchLogger;
  private loggingService: LoggingService;
  private testId: string | null;

  private constructor(dispatch: AppDispatch, testId: string | null) {
    this.dispatch = dispatch;
    this.loggingService = LoggingService.getInstance(dispatch);
    this.testId = testId;
  }

  static getInstance(
    dispatch: AppDispatch,
    testId: string | null = null
  ): DispatchLogger {
    if (!DispatchLogger.instance) {
      DispatchLogger.instance = new DispatchLogger(dispatch, testId);
    }

    return DispatchLogger.instance;
  }

  getTestId(): string | null {
    return this.testId;
  }

  /**
   * @todo: Come up with types for these params
   *
   * @param {*} action
   * @param {*} payload
   * @param {ILogMessage} log
   * @memberof DispatchLogger
   */
  fire(action: any, payload: any, log: ILogMessage): void {
    // @todo make action and payload optional
    if (action && payload) {
      this.dispatch(action(payload));
    }

    this.loggingService.logMessage(log);
  }
}
